import { createSelector } from '@reduxjs/toolkit';
const selectPinCreationState = (state) => state.pinCreation;
export const selectPinCreationModalOpen = createSelector([selectPinCreationState], state => state.isModalOpen);
export const selectPinCreationHasCheckedPin = createSelector([selectPinCreationState], state => state.hasCheckedPin);
export const selectPinCreationPreviousAccountId = createSelector([selectPinCreationState], state => state.previousAccountId);
